import React, { useContext } from "react";
import { Route, Routes } from "react-router-dom";

import { themeContext } from "../../../../shared/store/contexts";
import SettingsNavBar from "../../../molecules/SettingsNavBar";
import PageHero from "../../../molecules/PageHero";
import PasswordUpdate from "../../../templates/ProfileForms/form.password.update";
import ProfileUpdate from "../../../templates/ProfileForms/form.profile.update";

import Team from "../../../templates/Team";

const SettingsPage = () => {
  const { theme } = useContext(themeContext);

  return (
    <section className="flex flex-col w-full">
      <PageHero
        className="organization-container"
        title="Settings"
        description="Manage account settings"
      />
      <main className="organization-container py-10">
        <SettingsNavBar theme={theme} />

        <Routes>
          <Route element={<PasswordUpdate />} path="password-update" />
          <Route element={<Team />} path="team" />
          <Route element={<ProfileUpdate />} exact path="profile" />

          <Route element={<ProfileUpdate />} exact path="" />
        </Routes>
      </main>
    </section>
  );
};

export default SettingsPage;
